import http from '../http'
/**
 * 获取会员列表
 */
export const getList = () => {
    return http.get('/api/gm/userextend/getlist')
}
/**
 * 获取内容
 * @param  {number} id 权限制
}
 */
export const getAuthValue = id => {
    return http.get(`/api/gm/userextend/getauthvalue/${id}`)
}
/**
 * 添加会员扩展项
 * @param {FormData} userextend 用户,例:  {
    "account":'账号',
    "company": '公司名',
    "projectname": "项目名",
    "projectdescribe":'项目描述',
        "productids":[],
}
*/
export const adduserextend = userextend => {
    return http.post('/api/gm/userextend/add', userextend)
}
/**
 * 修改会员扩展项
 * @param {FormData} userextend 用户,例:  {
    "account":'账号',
    "company": '公司名',
    "projectname": "项目名",
    "projectdescribe":'项目描述',
        "productids":[],
}
*/
export const edituserextend = userextend => {
    return http.post('/api/gm/userextend/edit', userextend)
}
/**
 * 删除会员
 * @param {String} account 账号
 */
export const deleteUserExtend = account => {
    return http.get(`/api/gm/userextend/delete/${account}`)
}

/**
 * 判断是否是前台会员
 *  @param {String} account 账号
 */
export const getUserType = account => {
    return http.get(`/api/gm/userextend/frontuser/${account}`)
}


// WEBPACK FOOTER //
// ./src/api/gm/api-user.js